import store from '@/stores';
import TypistHub from '@/views/TypistHub.vue';
import ManagerHub from '@/views/ManagerHub.vue';

const name = 'hub';
const path = '/hub';

export default [
  // routes
  {
    name: `${name}`,
    path: `${path}`,
    component: TypistHub,
    beforeEnter: (to, from, next) => {
      // const roles = store.state.user.userInfo.roles_ids || [];
      // const validIds = [9];
      // const isValid = !!roles.find((id) => validIds.includes(id));

      // if (isValid) next();
      // else next({ name: 'fgts-proposal' });
      // next({ name: 'fgts-proposal' });
      next();
    },
  },
  {
    name: `${name}-manager`,
    path: `${path}-manager`,
    component: ManagerHub,
    beforeEnter: (to, from, next) => {
      const roles = store.state.user.userInfo.roles_ids || [];
      const validIds = [3, 6, 10, 11, 16, 18];
      console.log(store.state.user.userInfo.roles_ids);
      const isValid = !!roles.find((id) => validIds.includes(id));

      if (isValid) next();
      else next({ name: 'fgts-proposal' });
    },
  },
];
